export default __webpack_public_path__ + "static/media/vitalik_nft_7.29425b0b.svg";